import React from "react";

import { defaultBom } from "product_tabs/tab_parts/data/DefaultBOM";

const BomSample = () => {
  return (
    <div id="bom-sample-show-table" className='table-responsive bom-sample-table'>
      <div className='mb-3'>
        <h4 className='fw-bold'>BOM EXAMPLE</h4>
      </div>
      <table className="table table-bordered">
        <thead className="">
          <tr>
            {defaultBom[0].map((header, index) => {
              return (
                <th key={index} className="text-center">{header}</th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {defaultBom.slice(1).map((row, index) => {
            return (
              <tr key={index}>
                {row.map((cell, index) => {
                  return (
                    <td key={index} className="text-center">{cell}</td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default BomSample;